module.exports = __webpack_public_path__ + "static/enfants-e2b1b8ff9c6c41b0ba038099e65067c0.jpg";